import { EXPAND_FIELD_PREFIX } from '@constants'

export const getExpandedPath = (path: string) => {
  return path.split('.').map((item, index, array) => {
    if (index === array.length - 1) {
      return item
    }

    return EXPAND_FIELD_PREFIX + item
  })
}
